import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SlotTestResultItem')
export class SlotTestResultItem {

  @JsonProperty('rank', Number)
  rank: number = 0;

  @JsonProperty('count', Number)
  count: number = 0;

  @JsonProperty('percent', Number)
  percent: number = 0;
}
